import {useCallback, useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {
  selectBecomeCreatorData,
  setBecomeCreatorData,
} from '@/src/app/store/user/becomeCreatorSlice';

import PopupContext from '../../../popup/utils/PopupContext';
import BecomeCreatorWidgetLayout from '../components/BecomeCreatorWidgetLayout';
import BECOME_CREATOR_STATUSES from '../constants/becomeCreatorStatuses';
import fetchBecomeCreatorData from '../utils/fetchBecomeCreatorData';
import BecomeCreatorPopup from './BecomeCreatorPopup';

const BecomeCreatorWidget = () => {
  const {openPopup} = useContext(PopupContext);
  const dispatch = useDispatch();
  const becomeCreatorData = useSelector(selectBecomeCreatorData);

  const handleBecomeCreatorClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <BecomeCreatorPopup />,
      options: {withCloseButton: true},
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const {status, responseBody} = await fetchBecomeCreatorData();

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(
          setBecomeCreatorData({
            becomeCreatorData: responseBody.become_content_creator_request,
            doctorProfile: responseBody.doctor_profile,
            isFetched: true,
          })
        );
      }
    };

    if (!becomeCreatorData.isFetched) {
      fetchData();
    }
  }, [becomeCreatorData]);

  if (!becomeCreatorData.isFetched) {
    return null;
  }

  return (
    <BecomeCreatorWidgetLayout
      onBecomeCreatorClick={handleBecomeCreatorClick}
      becomeCreatorStatus={
        becomeCreatorData.becomeCreatorData
          ? becomeCreatorData.becomeCreatorData.status
          : BECOME_CREATOR_STATUSES.INITIAL
      }
    />
  );
};

export default BecomeCreatorWidget;
